module.exports = __webpack_public_path__ + "img/our-world-partner-rossetto-small.d36fbe79.jpg";